var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudAndDevopsSolutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22V27C9 27.5523 8.55228 28 8 28H5M14.5 22V30.0858C14.5 30.351 14.3946 30.6054 14.2071 30.7929L11.5 33.5M20 22.5V33.5",
    stroke: "white",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 22V27C31 27.5523 31.4477 28 32 28H35M25.5 22V30.0858C25.5 30.351 25.6054 30.6054 25.7929 30.7929L28.5 33.5M20 22.5V37",
    stroke: "white",
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.4737C1 19.5258 3.36294 22 6.27778 22H32.6667C36.1645 22 39 19.0309 39 15.3684C39 12.046 36.6666 9.29424 33.6222 8.81183C33.6879 8.42882 33.7222 8.03439 33.7222 7.63158C33.7222 3.96906 30.8867 1 27.3889 1C25.1463 1 23.176 2.22042 22.0507 4.06156C21.1329 3.51969 20.0732 3.21053 18.9444 3.21053C15.8063 3.21053 13.2012 5.60042 12.6987 8.73684H12.6111C10.7351 8.73684 9.08776 9.7617 8.15179 11.3059C7.56943 11.0742 6.93775 10.9474 6.27778 10.9474C3.36294 10.9474 1 13.4216 1 16.4737Z",
    stroke: "white",
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 28,
    r: 1.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 28,
    r: 1.5,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 35,
    r: 1.5,
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 35,
    r: 1.5,
    stroke: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 39,
    r: 1.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAndDevopsSolutionIcon);
export default __webpack_public_path__ + "static/media/cloudAndDevopsSolutionIcon.79808f26a1900aca29bc8b8c40276a88.svg";
export { ForwardRef as ReactComponent };